import { observer } from 'mobx-react-lite'
import { EmptyState, type IRow, Table, variantActionsProps } from 'shared/ui'
import type { ITrigger } from 'entities/Trigger/model/Trigger'
import { TriggersRoutes } from 'entities/ExportRouters'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useTriggerListContext } from 'widgets/TriggerList/context/context'
import { getTriggerActions } from 'widgets/TriggerActions/getTriggerActions'
import { BulkActions } from '../BulkActions'
import { getColumns } from './getColumns'
import styles from './styles.module.scss'

export const TriggersTable = observer(() => {
  const {
    triggers,
    type,
    tableStore,
    onPaginationModelChange,
    isNoSearchResults,
    isLoading,
    isFirstLoading,
    page,
    limit,
    total,
    onDelete,
  } = useTriggerListContext()
  const entities = useEntitiesContext()

  const getRowLink = (row: IRow<ITrigger>) =>
    `/${TriggersRoutes.root}/${TriggersRoutes.view}/${row.id}`

  const getRows = () => {
    return triggers.map((trigger) => {
      trigger.setActionsProps({
        ...variantActionsProps.table,
        actions: getTriggerActions({
          trigger: trigger,
          onSuccessDelete: () => onDelete(trigger.id),
        }),
      })

      return trigger
    })
  }

  if (isNoSearchResults) {
    return <EmptyState text='No triggers found' />
  }

  return (
    <div className={styles.wrap}>
      <Table
        ariaLabel={'TriggersTable'}
        withCheckbox
        store={tableStore}
        headerLeftContentProps={{
          actionsContent: <BulkActions />,
        }}
        columns={getColumns(type, entities)}
        pinnedColumnNames={['name']}
        rows={getRows()}
        getRowLink={getRowLink}
        rowsCount={total}
        isLoading={isFirstLoading || isLoading}
        onChangePagination={onPaginationModelChange}
        initPage={page}
        limit={limit}
        sortBy={tableStore.sortBy}
        startPaginationSize={10}
      />
    </div>
  )
})
